import type { CSSProperties } from 'react';
import type { UserRole } from 'types/User';

export const ANALYTICS_DATA_STALE_TIME_MS = 5 * 60 * 1000;

export const ANALYTICS_MAX_SELECTED_GROUP_PROFILES = 30;

// TODO: set to `true` to bring back the content summary metric cards.
export const CONTENT_SUMMARY_METRICS_ENABLED = false;

export const analyticsSectionOuterClassName = 'tw-px-1 tw-pt-3';

export const analyticsSectionBackgroundStyle: CSSProperties = {
  borderRadius: 'var(--3x, 12px)',
  background:
    'linear-gradient(273deg, rgba(121, 54, 204, 0.20) 2.37%, rgba(131, 54, 162, 0.20) 50.41%, rgba(202, 56, 86, 0.20) 97.55%)',
};

export const NEW_ANALYTICS_ACCOUNT_PUBLIC_IDS: readonly string[] = [
  '214562848669161e8a67be', // digitaliko
  '1563878939632af74e3309e', // allfred
  'b39a4d42f8a9ed', // kontentinoapp
  '193259845160d70105269d5', // eva
  '99ebb4eb6b2f0e', // kontentino2
  '4085541435ed6766db731f', // dev1
  '15828119615fb4ee44d1ef3', // dev6
  '3854849265ed6770460635', // dev2
  '2958200345ed677dfe1666', // dev3,
  '9518831085ed67843b54ff', // dev5
  '49605371660d5ab0121817', // dev9
  '9067997265ed6782d1b523', // dev4
  '1644341203659bad864b48b', // dim
  '70571316265c0ebc8717ba', // dev11
];

export const NEW_ANALYTICS_ACCOUNT_IDS: readonly number[] = [
  61419, // industriensudd
  59418, // klararott
  68756, // moresocial
  68223, // 101drogeria
  61809, // justtesting
  68410, // ekomenu
  55182, // futurefox
  68115, // cordeel
  63745, // test-automation
  60818, // socialspark
  68844, // junonaandersone
  42453, // vermeiren
  15352, // social-drum
  60158, // miramis
  62440, // fccecee
  55617, // headlineagency
  35984, // czechfloorball
  68987, // dennikpostoj
  61810, // gadrilling
  10666, // thecollective
  10226, // netsuccess
  63835, // wilsondo
  49326, // marticom
  52875, // bubomkt
  3737, // bdf
  56141, // cat2lion
  62987, // aalberts-hfc
  69219, // Archetype
  59426, // lansingunitra1873 (NPS)
  9788, // forfarmers-test
  2552, // getagrip
  59126, // houseofrezac
  30693, // feat
  4689, // hannibal
  60974, // avantgroup
  69438, // marketing-sask
  39196, // fafashionable
  25244, // oona
  63907, // klau-fitatu
  69696, // digitsol
  68829, // tigers
  69737, // liftwithcee
  31924, // confetti
  61639, // tbwa
  1950, // futurelife
  69595, // fluvius
  38747, // socially
  21002, // nadacejt
  47195, // krasno-studio
  14369, // kkcgroup
  58336, // efbelgium
  70026, // rangitoopuni
  46579, // marketmeagency
  69419, // relactions
  30938, // sliced
  3344, // digit
  46981, // hartela
  32296, // impactstudio
  70019, // raudnael
  4168, // ccl
  43584, // essers-corporate
  70450, // nouvelleenergie69
  70520, // ims-trenchless
  9292, // media-architect
  37177, // dfvsmu
  44954, // xtb
  70265, // ogilvy
  70074, // ckmsyts
  49502, // studio-ravelle
  50399, // folkstudio
  50183, // tocomfy
  6104, // nakaza
  34416, // salesatsize
  18848, // mcc
  4185, // quenyatech
  71088, // evenementensilverfit
  20838, // wrongdigital
  71003, // ellenroels404
  71259, // interway
  71151, // marketinggmdh
];

export function isNewAnalyticsAccountPublicId(publicId: string): boolean {
  return NEW_ANALYTICS_ACCOUNT_PUBLIC_IDS.includes(publicId);
}

export function isNewAnalyticsAccountId(
  accountId: number | null | undefined,
): boolean {
  return accountId != null && NEW_ANALYTICS_ACCOUNT_IDS.includes(accountId);
}

export function canAccessNewAnalytics(
  accountPublicId: string,
  role: UserRole,
  accountId?: number | null,
): boolean {
  return (
    isNewAnalyticsAccountPublicId(accountPublicId) ||
    isNewAnalyticsAccountId(accountId)
  );
}
